import { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { LoadingComponent } from '../../components/global/LoadingComponent.tsx';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary.tsx';

const PdpRespZoomModalLazy = lazy(() =>
    import(
        /* webpackChunkName: "PdpRespZoomModalWrapper" */
        './PdpRespZoomModalWrapper.jsx'
    ).then(PdpRespZoomModal => ({ default: PdpRespZoomModal.PdpRespZoomModalWrapper }))
);

export function PdpRespZoomModalLoader(props) {
    if (!props.isOpen) {
        return null;
    }
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={<LoadingComponent />}>
                <PdpRespZoomModalLazy {...props} />
            </Suspense>
        </ErrorBoundary>
    );
}

PdpRespZoomModalLoader.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};
